// extracted by mini-css-extract-plugin
export default {"buttonCard":"Card_buttonCard__+kNle","card":"Card_card__V+fj1"};